import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { openAiRateLimitStats } from "./constants";
import type { OpenAiRateLimitStats } from "./types";

export const getOpenAiRateLimitStats = reactQueryFetcherAdapter(
  openAiRateLimitStats,
  (signal: AbortSignal, endpoint: string): Promise<OpenAiRateLimitStats> => {
    return fetch(
      "/generative_ai/rate_limit_stats",
      "GET",
      {
        endpoint: endpoint,
      },
      { signal }
    );
  }
);
